module.exports = __webpack_public_path__ + "img/body.d6ad7b81.png";